/**
 * @generated SignedSource<<755ee4fdc15eeb1d429180ce9f242ead>>
 * @relayHash 478a65a5e586d07574b5bbd2cc4ef630
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50f41ae3db36d1741d384023d13472ac68cccc88abdb8a72fb04d3f7c9bc8670

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcIncidentsPageInternalQuery } from './srcIncidentsPageInternalQuery.graphql';

const node: PreloadableConcreteRequest<srcIncidentsPageInternalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "50f41ae3db36d1741d384023d13472ac68cccc88abdb8a72fb04d3f7c9bc8670",
    "metadata": {
      "connection": [
        {
          "count": "servicePageSize",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "jiraProjectByKey",
            "linkedOperationsComponentsByProject"
          ]
        }
      ]
    },
    "name": "srcIncidentsPageInternalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
